import React, { FC, useContext } from 'react';
import PortfolioDataRoomNodes from 'router/subrouters/Dash/subrouters/private/components/PortfolioDataRoomNodes';
import LeadContext from '../../providers/Lead/Lead.context';
import BuyerNdaCard from 'router/subrouters/Dash/subrouters/private/components/BuyerNdaCard';
import NextStep from '../NextStep';

const ListingInfoAside: FC = () => {
  const {
    leadId,
    envelopeId,
    signingStatus,
    signedDate,
    manuallySetNDAStatus,
    rejectionReason,
    listing: { envelopeTemplateName, dataRoomId, dataRoomNodes },
    dealRoom: { name },
    updateNdaProps,
  } = useContext(LeadContext);

  return (
    <aside>
      <NextStep />

      <BuyerNdaCard
        leadId={leadId}
        signingStatus={signingStatus}
        envelopeId={envelopeId}
        signedDate={signedDate}
        rejectionReason={rejectionReason}
        manuallySetNDAStatus={manuallySetNDAStatus}
        envelopeTemplateName={envelopeTemplateName}
        updateNdaProps={updateNdaProps}
      />

      <PortfolioDataRoomNodes
        dataRoomId={dataRoomId}
        dataRoomNodes={dataRoomNodes}
        dataRoomName={name}
      />
    </aside>
  );
};

export default ListingInfoAside;
